import AppSearch from "views/AppSearch/AppSearch.js";
import Guide from "views/Guide/Guide.js";
import About from "views/About/About.js";
import Settings from "views/Settings/Settings.js";
import UserProfile from "views/Pages/UserProfile";
import EditProfile from "views/Pages/EditProfile";
import LoginPage from "views/Pages/LoginPage";
import RegisterPage from "views/Pages/RegisterPage";
import ResetPassword from "views/Pages/ResetPassword";
import ResetPassConfirm from "views/Pages/ResetPassConfirm";
import OLDDashboard from "views/OLDDashboard/OLDDashboard.js";

// i18n (sin hooks, sin importar JSON)
import i18n from "i18n/config";

// @material-ui/icons
import SearchIcon from "@material-ui/icons/Search";
import DescriptionIcon from "@material-ui/icons/Description";
import PolicyIcon from "@material-ui/icons/Policy";
import InfoIcon from "@material-ui/icons/Info";
import SettingsIcon from "@material-ui/icons/Settings";

var dashRoutes = [
  {
    path: "/search",
    name: i18n.t("search", { ns: "menu" }),
    icon: SearchIcon,
    component: AppSearch,
    layout: "",
  },
  {
    path: "/guide",
    name: i18n.t("userGuide", { ns: "menu" }),
    icon: DescriptionIcon,
    component: Guide,
    layout: "",
  },
  {
    path: "/privacy",
    name: i18n.t("privacyPolicy", { ns: "menu" }),
    icon: PolicyIcon,
    privacyConditional: true,
    layout: "",
  },
  {
    path: "/about",
    name: i18n.t("aboutUs", { ns: "menu" }),
    icon: InfoIcon,
    component: About,
    layout: "",
  },
  {
    path: "/settings",
    name: i18n.t("settings", { ns: "menu" }),
    icon: SettingsIcon,
    component: Settings,
    layout: "",
  },
  {
    path: "/profile",
    component: UserProfile,
    layout: "",
    hidden: true,
    private: true,
  },
  {
    path: "/profile/edit",
    component: EditProfile,
    layout: "",
    hidden: true,
    private: true,
  },
  {
    path: "/register",
    component: RegisterPage,
    layout: "",
    hidden: true,
  },
  {
    path: "/login",
    component: LoginPage,
    layout: "",
    hidden: true,
  },
  {
    path: "/resetpassword",
    component: ResetPassword,
    layout: "",
    hidden: true,
  },
  {
    path: "/resetpassword/confirm/:token",
    component: ResetPassConfirm,
    layout: "",
    hidden: true,
  },
  {
    path: "/OLDdashboard",
    component: OLDDashboard,
    layout: "",
    hidden: true,
  },
];

export default dashRoutes;